export default __webpack_public_path__ + "static/media/tiendanube-platform-poster.a8f8f89b.png";